/**
 * Veluna Full-Screen Email Capture - Homepage Version
 * Multi-trigger: Scroll + Exit Intent + Timer
 */

(function() {
  'use strict';

  console.log('[Veluna Popup] ======= SCRIPT LOADED =======');

  const CONFIG = {
    accountId: '1614849',
    forms: {
      popup: '176459260991899613',
      footer: '176459260517943202'
    },
    timing: {
      countdownSeconds: 30,
      timerDelay: 45000  // 45 seconds as fallback
    },
    storage: {
      captured: 'veluna_email_captured',
      shown: 'veluna_popup_shown'
    },
    scrollThreshold: 50,  // Show after 50% scroll
    sleepConcerns: [
      { id: 'mc', label: 'Racing Thoughts & Stress', ritual: 'Mind Calm', product: '/products/mind-calm-ritual-set', guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/t/706/assets/Veluna-Mind-Calm-Sleep-Guide.pdf?v=1783624257' },
      { id: 'dr', label: 'Body Tension & Restlessness', ritual: 'Deep Restore', product: '/products/deep-restore-ritual-set', guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/t/706/assets/Veluna-Deep-Restore-Sleep-Guide.pdf?v=1783624258' },
      { id: 'ss', label: 'Self-Care & Transformation', ritual: 'Sacred Soothe', product: '/products/sacred-soothe-ritual-set-1', guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/t/706/assets/Veluna-Sacred-Soothe-Sleep-Guide.pdf?v=1783624259' },
      { id: 'cr', label: 'Sleep Schedule & Timing', ritual: 'Circadian Reset', product: '/products/circadian-reset-ritual-set', guide: 'https://cdn.shopify.com/s/files/1/0660/1372/4750/t/706/assets/Veluna-Circadian-Reset-Sleep-Guide.pdf?v=1783624260' }
    ]
  };

  let popupVisible = false;
  let popupElement = null;
  let countdownInterval = null;
  let selectedConcern = null;

  // Blog auto-preselect: if article-conversion.liquid set a cluster, skip step 1
  function getBlogCluster() {
    try {
      var c = window.VELUNA_BLOG_CLUSTER;
      if (c && CONFIG.sleepConcerns.find(function(x){return x.id === c;})) return c;
    } catch(e) {}
    return null;
  }

  function fireJarvis(name, extra) {
    try {
      var payload = Object.assign({
        cluster: window.VELUNA_BLOG_CLUSTER || '',
        article: window.VELUNA_BLOG_ARTICLE_HANDLE || '',
        path: window.location.pathname
      }, extra || {});
      if (typeof gtag !== 'undefined') {
        gtag('event', name, { event_category: 'Blog Popup', event_label: payload.cluster, page_path: payload.path });
      }
      if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, payload));
      if (typeof fbq !== 'undefined' && name === 'blog_popup_email_submit') {
        fbq('track', 'Lead', { content_name: 'blog_pdf_guide', content_category: payload.cluster });
      }
    } catch(e) {}
  }

  // This one component serves both the homepage and blog articles. Source and
  // sequence follow the surface, using conventions already present in the
  // subscriber table (article_capture / homepage_popup) and the engine
  // (article_welcome is the enabled Article Welcome Flow, identical content to
  // welcome but a distinct sequence_id so article leads stay segmentable).
  const CAPTURE_ID = 'article-capture';
  const VELUNA_SUBSCRIBE_ENDPOINT =
    'https://ary09mimgg.execute-api.us-east-2.amazonaws.com/Prod/subscribe';

  function isArticleSurface() {
    const p = window.location.pathname;
    return p.includes('/blogs/') && p.split('/').length > 3;
  }
  function captureSource() { return isArticleSurface() ? 'article_capture' : 'homepage_popup'; }
  function captureSequence() { return isArticleSurface() ? 'article_welcome' : 'welcome'; }

  try {
    if (isArticleSurface()) {
      (window.__vlnPageSpecific = window.__vlnPageSpecific || []).push(CAPTURE_ID);
      window.VelunaCaptureGuard && window.VelunaCaptureGuard.registerPageSpecific(CAPTURE_ID);
    }
  } catch (e) {}

  function shouldShowPopup() {
    // Article-only. The homepage is served by the generic site-wide PDF/guide
    // capture; running both there was a race with no deterministic winner.
    if (!isArticleSurface()) {
      console.log('[Veluna Popup] Skipping - homepage is served by the site-wide capture');
      return false;
    }
    // Skip on checkout
    if (window.location.pathname.includes('/checkout')) {
      console.log('[Veluna Popup] Skipping - checkout page');
      return false;
    }
    
    // Only show on homepage or blog articles
    const isHomepage = window.location.pathname === '/' || window.location.pathname === '/index';
    const isBlogArticle = window.location.pathname.includes('/blogs/') && window.location.pathname.split('/').length > 3;
    
    if (!isHomepage && !isBlogArticle) {
      console.log('[Veluna Popup] Skipping - not homepage or blog article');
      return false;
    }
    
    // Check if email was captured or popup already shown in this session
    const captured = localStorage.getItem(CONFIG.storage.captured);
    if (captured === 'true') {
      console.log('[Veluna Popup] Skipping - email already captured');
      return false;
    }
    
    const shown = sessionStorage.getItem(CONFIG.storage.shown);
    if (shown === 'true') {
      console.log('[Veluna Popup] Skipping - already shown this session');
      return false;
    }
    
    // Single arbitration authority. This popup previously rendered with no
    // regard for other capture engines, which is how the homepage ended up
    // showing two full-viewport overlays at once.
    try {
      if (window.VelunaCaptureGuard && !window.VelunaCaptureGuard.mayShow(CAPTURE_ID)) {
        console.log('[Veluna Popup] Suppressed by capture guard:',
                    window.VelunaCaptureGuard.reason(CAPTURE_ID));
        return false;
      }
    } catch (e) {}

    console.log('[Veluna Popup] Will show popup based on triggers');
    return true;
  }

  function createFullScreenPopup() {
    const popup = document.createElement('div');
    popup.className = 'veluna-fs-popup';
    popup.innerHTML = `
      <button class="veluna-fs-close" data-close aria-label="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>

      <div class="veluna-fs-container">
        <!-- Step 1: Select Concern -->
        <div class="veluna-fs-step veluna-fs-step--active" data-step="1">
          <div class="veluna-fs-timer" data-countdown>0:30</div>
          
          <h1 class="veluna-fs-heading">Get Your Free<br><span>Sleep Ritual Guide</span></h1>
          <p class="veluna-fs-subtext">Tell us your sleep challenge to get your personalized guide:</p>
          
          <div class="veluna-fs-options">
            ${CONFIG.sleepConcerns.map((c, i) => `
              <button class="veluna-fs-option" data-concern="${c.id}">
                <span class="veluna-fs-option-num">${i + 1}</span>
                <span class="veluna-fs-option-text">${c.label}</span>
                <span class="veluna-fs-option-arrow">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 18l6-6-6-6"/>
                  </svg>
                </span>
              </button>
            `).join('')}
          </div>
          
          <button class="veluna-fs-skip" data-skip>Skip and browse</button>
        </div>

        <!-- Step 2: Email Capture -->
        <div class="veluna-fs-step" data-step="2">
          <div class="veluna-fs-timer" data-countdown>0:30</div>
          
          <div class="veluna-fs-reveal">
            <span class="veluna-fs-reveal-num">$47</span>
            <span class="veluna-fs-reveal-text">VALUE GUIDE</span>
          </div>
          
          <h1 class="veluna-fs-heading">Your <span data-ritual-name>Ritual</span> Guide<br>is Ready</h1>
          <p class="veluna-fs-subtext">Enter your email to unlock your personalized sleep ritual guide:</p>
          
          <form class="veluna-fs-form" data-form>
            <input type="email" class="veluna-fs-input" placeholder="Your email address" required data-email-input>
            <button type="submit" class="veluna-fs-submit">Get My Free Guide</button>
          </form>
          
          <p class="veluna-fs-privacy">No spam. Unsubscribe anytime.</p>
        </div>

        <!-- Step 3: Success -->
        <div class="veluna-fs-step" data-step="3">
          <div class="veluna-fs-success-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          
          <h1 class="veluna-fs-heading">Check Your Email</h1>
          <p class="veluna-fs-subtext">Your <span data-ritual-name>Sleep Ritual</span> Guide is on its way.<br>While you wait, explore your recommended ritual set:</p>
          
          <a href="#" class="veluna-fs-product-btn" data-product-link>
            View <span data-ritual-name>Your</span> Ritual Set
          </a>
          
          <button class="veluna-fs-skip" data-close>Continue browsing</button>
        </div>
      </div>
    `;
    
    return popup;
  }

  function showPopup() {
    console.log('[Veluna Popup] ========== SHOWING POPUP ==========');
    if (popupVisible) return;

    injectStyles();
    popupElement = createFullScreenPopup();
    popupElement.setAttribute('data-capture-id', CAPTURE_ID);
    popupElement.setAttribute('data-veluna-article-popup', '');
    popupElement.classList.add('is-open');
    document.body.appendChild(popupElement);
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyOpen(CAPTURE_ID); } catch (e) {}
    
    // Force reflow
    popupElement.offsetHeight;
    
    // Animate in
    requestAnimationFrame(() => {
      popupElement.classList.add('veluna-fs-popup--visible');
    });
    
    popupVisible = true;
    document.body.style.overflow = 'hidden';
    
    // Mark as shown in this session
    sessionStorage.setItem(CONFIG.storage.shown, 'true');
    
    bindPopupEvents();
    startCountdown();

    fireJarvis('blog_popup_shown');

    // Blog: auto-preselect cluster → skip step 1 (1-tap to email)
    var preCluster = getBlogCluster();
    if (preCluster) {
      try { selectConcern(preCluster); } catch(e) {}
    }

    console.log('[Veluna Popup] Popup displayed successfully');
  }

  function hidePopup() {
    try {
      if (popupElement) popupElement.classList.remove('is-open');
      window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyClosed(CAPTURE_ID);
    } catch (e) {}
    if (!popupElement) return;

    fireJarvis('blog_popup_dismissed');

    popupElement.classList.remove('veluna-fs-popup--visible');
    
    setTimeout(() => {
      if (popupElement && popupElement.parentNode) {
        popupElement.parentNode.removeChild(popupElement);
      }
      popupElement = null;
      popupVisible = false;
      document.body.style.overflow = '';
    }, 300);

    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  }

  function bindPopupEvents() {
    if (!popupElement) return;

    // Close buttons
    popupElement.querySelectorAll('[data-close]').forEach(btn => {
      btn.addEventListener('click', () => hidePopup());
    });

    // Skip button
    popupElement.querySelectorAll('[data-skip]').forEach(btn => {
      btn.addEventListener('click', () => hidePopup());
    });

    // Click outside to close
    popupElement.addEventListener('click', (e) => {
      if (e.target === popupElement) {
        hidePopup();
      }
    });

    // Concern options
    popupElement.querySelectorAll('[data-concern]').forEach(btn => {
      btn.addEventListener('click', () => {
        const concernId = btn.dataset.concern;
        selectConcern(concernId);
      });
    });

    // Form submission
    const form = popupElement.querySelector('[data-form]');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        submitEmail();
      });
    }

    // ESC to close
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape' && popupVisible) {
        hidePopup();
        document.removeEventListener('keydown', escHandler);
      }
    });
  }

  function selectConcern(concernId) {
    selectedConcern = CONFIG.sleepConcerns.find(c => c.id === concernId);
    if (!selectedConcern) return;

    // Update ritual name placeholders
    popupElement.querySelectorAll('[data-ritual-name]').forEach(el => {
      el.textContent = selectedConcern.ritual;
    });

    // Update product link — prefer the article's resolved product URL when present
    var productHref = (window.VELUNA_BLOG_PRODUCT_URL && window.VELUNA_BLOG_CLUSTER === concernId)
      ? window.VELUNA_BLOG_PRODUCT_URL
      : selectedConcern.product;
    const productLink = popupElement.querySelector('[data-product-link]');
    if (productLink) {
      productLink.href = productHref;
    }

    fireJarvis('blog_popup_concern_selected', { concern: concernId });
    goToStep(2);
  }

  function goToStep(step) {
    popupElement.querySelectorAll('[data-step]').forEach(el => {
      el.classList.remove('veluna-fs-step--active');
      if (parseInt(el.dataset.step) === step) {
        el.classList.add('veluna-fs-step--active');
      }
    });
  }

  function submitEmail() {
    const input = popupElement.querySelector('[data-email-input]');
    const email = input ? input.value.trim() : '';

    if (!isValidEmail(email)) {
      input.style.borderColor = '#c9a86c';
      input.focus();
      return;
    }

    // Submit to the canonical Veluna email engine.
    //
    // This used to call ml('subscribe', ...) into MailerLite, which has 41
    // automations with 0 enabled and 0 sent campaigns. Every article lead
    // captured here was therefore created as a MailerLite prospect and never
    // entered the Veluna lifecycle: no subscriber row, no sequence, no email.
    const concernId = selectedConcern ? selectedConcern.id : 'mc';
    const sequence = captureSequence();
    const source = captureSource();
    try {
      fetch(VELUNA_SUBSCRIBE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          email: email,
          topic: 'popup_subscribe',
          source: source,
          email_sequence: sequence,
          popup_variant: source,
          concern: concernId,
          tags: [source, 'concern_' + concernId, sequence],
          fields: {
            sleep_concern: concernId,
            ritual_type: selectedConcern ? selectedConcern.ritual : '',
            email_sequence: sequence,
            popup_variant: source
          },
          metadata: {
            page: window.location.pathname,
            referrer: document.referrer || '',
            user_agent: (navigator && navigator.userAgent) || ''
          }
        })
      }).catch(() => null);
    } catch (e) {}

    // Mark email as captured
    localStorage.setItem(CONFIG.storage.captured, 'true');

    fireJarvis('blog_popup_email_submit', { concern: selectedConcern ? selectedConcern.id : '' });

    // Trigger guide download
    if (selectedConcern && selectedConcern.guide) {
      window.open(selectedConcern.guide, '_blank');
    }

    goToStep(3);

    // Auto-close after 5 seconds
    setTimeout(() => hidePopup(), 5000);
  }

  function startCountdown() {
    let seconds = CONFIG.timing.countdownSeconds;
    const countdownEls = popupElement.querySelectorAll('[data-countdown]');

    function updateCountdown() {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      const display = `${mins}:${secs.toString().padStart(2, '0')}`;
      countdownEls.forEach(el => el.textContent = display);
    }

    updateCountdown();
    countdownInterval = setInterval(() => {
      seconds--;
      updateCountdown();
      if (seconds <= 0) clearInterval(countdownInterval);
    }, 1000);
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function init() {
    console.log('[Veluna Popup] Initializing...');
    
    if (!shouldShowPopup()) return;

    // Load MailerLite Universal
    /* MailerLite universal.js loader REMOVED 2026-09-06.
       This capture no longer submits to MailerLite (it posts to the canonical
       Veluna intake), and nothing else in the theme uses the `ml` global. The
       loader was pure third-party runtime weight on every article page.
       The MailerLite account, its historical contacts, its DNS records and the
       Shopify MailerLite app are all untouched — only this dead frontend
       loader is gone. */

    console.log('[Veluna Popup] Setting up triggers: scroll (50%) + exit intent + timer (45s)');
    
    let triggered = false;
    
    // Trigger 1: Scroll depth (50% of page)
    function checkScroll() {
      if (triggered) return;
      
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      
      if (scrollPercent >= CONFIG.scrollThreshold) {
        triggered = true;
        console.log('[Veluna Popup] Triggered by scroll (' + Math.round(scrollPercent) + '%)');
        showPopup();
        window.removeEventListener('scroll', checkScroll);
      }
    }
    
    window.addEventListener('scroll', checkScroll, { passive: true });
    
    // Trigger 2: Exit intent (desktop mouseleave at top edge)
    document.addEventListener('mouseleave', function(e) {
      if (triggered) return;
      if (e.clientY <= 0) {
        triggered = true;
        console.log('[Veluna Popup] Triggered by exit intent');
        showPopup();
      }
    });

    // Trigger 2b: Mobile exit signals (visibility, pagehide, blur on touch device)
    var isTouch = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    document.addEventListener('visibilitychange', function() {
      if (triggered) return;
      if (document.visibilityState === 'hidden') {
        triggered = true;
        console.log('[Veluna Popup] Triggered by visibility hidden (mobile)');
        showPopup();
      }
    });
    window.addEventListener('pagehide', function() {
      if (triggered) return;
      triggered = true;
      console.log('[Veluna Popup] Triggered by pagehide (mobile)');
      showPopup();
    });
    if (isTouch) {
      // Mobile back-button intent
      try { history.pushState({ veluna_hp_exit: 1 }, ''); } catch (e) {}
      window.addEventListener('popstate', function() {
        if (triggered) return;
        triggered = true;
        console.log('[Veluna Popup] Triggered by back button (mobile)');
        showPopup();
        try { history.pushState({ veluna_hp_exit: 1 }, ''); } catch (e) {}
      });
      // Mobile scroll-up after deep scroll
      var maxY = 0, scrollUpFired = false;
      window.addEventListener('scroll', function() {
        if (triggered || scrollUpFired) return;
        var y = window.scrollY || 0;
        if (y > maxY) maxY = y;
        if (maxY > 700 && y < maxY - 300) {
          scrollUpFired = true;
          triggered = true;
          console.log('[Veluna Popup] Triggered by scroll-up (mobile)');
          showPopup();
        }
      }, { passive: true });
    }
    
    // Trigger 3: Time on page (45 seconds fallback)
    setTimeout(function() {
      if (!triggered) {
        triggered = true;
        console.log('[Veluna Popup] Triggered by timer (45s)');
        showPopup();
      }
    }, CONFIG.timing.timerDelay);
  }

  function injectStyles() {
    if (document.getElementById('veluna-fs-styles')) return;

    const style = document.createElement('style');
    style.id = 'veluna-fs-styles';
    style.textContent = `
      /* VELUNA BRANDED POPUP - Navy/Cream/Gold */
      .veluna-fs-popup {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(26, 31, 53, 0.95);
        backdrop-filter: blur(8px);
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      }

      .veluna-fs-popup--visible {
        opacity: 1;
        visibility: visible;
      }

      .veluna-fs-close {
        position: absolute;
        top: 24px;
        right: 24px;
        width: 48px;
        height: 48px;
        border: none;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #f5f0e8;
        transition: background 0.2s;
        z-index: 10;
      }

      .veluna-fs-close:hover {
        background: rgba(255, 255, 255, 0.2);
      }

      .veluna-fs-container {
        width: 90%;
        max-width: 520px;
        background: linear-gradient(145deg, #1a1f35, #0f1322);
        border-radius: 16px;
        padding: 48px 40px;
        position: relative;
        box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5);
        border: 1px solid rgba(201, 168, 108, 0.2);
        max-height: 90vh;
        overflow-y: auto;
      }

      .veluna-fs-step {
        display: none;
        text-align: center;
      }

      .veluna-fs-step--active {
        display: block;
        animation: velunaFadeIn 0.3s ease;
      }

      @keyframes velunaFadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
      }

      .veluna-fs-timer {
        display: inline-block;
        background: linear-gradient(135deg, #c9a86c, #b8956a);
        color: #1a1f35;
        padding: 10px 24px;
        border-radius: 30px;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1px;
        margin-bottom: 28px;
      }

      .veluna-fs-heading {
        color: #f5f0e8;
        font-size: 32px;
        font-weight: 600;
        line-height: 1.2;
        margin: 0 0 16px 0;
        letter-spacing: -0.5px;
      }

      .veluna-fs-heading span {
        color: #c9a86c;
      }

      .veluna-fs-subtext {
        color: rgba(245, 240, 232, 0.7);
        font-size: 16px;
        margin: 0 0 32px 0;
        line-height: 1.6;
      }

      .veluna-fs-options {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 24px;
      }

      .veluna-fs-option {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 18px 20px;
        background: rgba(245, 240, 232, 0.05);
        border: 1px solid rgba(201, 168, 108, 0.2);
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s;
        text-align: left;
        width: 100%;
        color: #f5f0e8;
      }

      .veluna-fs-option:hover {
        background: rgba(201, 168, 108, 0.15);
        border-color: rgba(201, 168, 108, 0.5);
        transform: translateX(4px);
      }

      .veluna-fs-option-num {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #c9a86c, #b8956a);
        color: #1a1f35;
        border-radius: 50%;
        font-size: 14px;
        font-weight: 700;
        flex-shrink: 0;
      }

      .veluna-fs-option-text {
        flex: 1;
        font-size: 15px;
        font-weight: 500;
      }

      .veluna-fs-option-arrow {
        color: rgba(201, 168, 108, 0.6);
        transition: transform 0.2s;
      }

      .veluna-fs-option:hover .veluna-fs-option-arrow {
        transform: translateX(4px);
        color: #c9a86c;
      }

      .veluna-fs-skip {
        background: none;
        border: none;
        color: rgba(245, 240, 232, 0.5);
        font-size: 14px;
        cursor: pointer;
        padding: 8px;
        transition: color 0.2s;
      }

      .veluna-fs-skip:hover {
        color: rgba(245, 240, 232, 0.8);
      }

      .veluna-fs-reveal {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 24px;
      }

      .veluna-fs-reveal-num {
        font-size: 56px;
        font-weight: 700;
        color: #c9a86c;
        line-height: 1;
      }

      .veluna-fs-reveal-text {
        color: rgba(245, 240, 232, 0.6);
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 3px;
        margin-top: 4px;
      }

      .veluna-fs-form {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 16px;
      }

      .veluna-fs-input {
        padding: 18px 20px;
        font-size: 16px;
        border: 1px solid rgba(201, 168, 108, 0.3);
        border-radius: 12px;
        background: rgba(245, 240, 232, 0.05);
        color: #f5f0e8;
        outline: none;
        transition: border-color 0.2s;
      }

      .veluna-fs-input:focus {
        border-color: #c9a86c;
      }

      .veluna-fs-input::placeholder {
        color: rgba(245, 240, 232, 0.4);
      }

      .veluna-fs-submit {
        padding: 18px 32px;
        font-size: 16px;
        font-weight: 600;
        color: #1a1f35;
        background: linear-gradient(135deg, #c9a86c, #b8956a);
        border: none;
        border-radius: 12px;
        cursor: pointer;
        transition: transform 0.2s, box-shadow 0.2s;
      }

      .veluna-fs-submit:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(201, 168, 108, 0.3);
      }

      .veluna-fs-privacy {
        color: rgba(245, 240, 232, 0.4);
        font-size: 12px;
        margin: 0;
      }

      .veluna-fs-success-icon {
        margin-bottom: 24px;
        color: #c9a86c;
      }

      .veluna-fs-product-btn {
        display: inline-block;
        padding: 18px 36px;
        font-size: 16px;
        font-weight: 600;
        color: #1a1f35;
        background: linear-gradient(135deg, #c9a86c, #b8956a);
        border-radius: 12px;
        text-decoration: none;
        margin-bottom: 16px;
        transition: transform 0.2s, box-shadow 0.2s;
      }

      .veluna-fs-product-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(201, 168, 108, 0.3);
        color: #1a1f35;
      }

      @media (max-width: 600px) {
        .veluna-fs-container {
          padding: 32px 24px;
          margin: 16px;
          border-radius: 12px;
        }
        
        .veluna-fs-heading {
          font-size: 26px;
        }
        
        .veluna-fs-option {
          padding: 14px 16px;
        }

        .veluna-fs-close {
          top: 16px;
          right: 16px;
          width: 40px;
          height: 40px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Expose helpers for testing
  window.VelunaPopup = {
    show: function() {
      injectStyles();
      showPopup();
    },
    hide: hidePopup,
    reset: function() {
      localStorage.removeItem(CONFIG.storage.captured);
      sessionStorage.removeItem(CONFIG.storage.shown);
      console.log('[Veluna Popup] Reset - refresh to test');
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
